const DownloadIcon = (): JSX.Element => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15L11.2929 15.7071L12 16.4142L12.7071 15.7071L12 15ZM11 3L11 15H13L13 3L11 3ZM15.2929 10.2929L11.2929 14.2929L12.7071 15.7071L16.7071 11.7071L15.2929 10.2929ZM12.7071 14.2929L8.70711 10.2929L7.29289 11.7071L11.2929 15.7071L12.7071 14.2929Z"
        fill="currentColor"
      />
      <path
        d="M4 17V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V17"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export default DownloadIcon;
